import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-ink"><Loader2 className="animate-spin text-primary" size={32} /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
